<!--
  What an order is billing for. Most of what this portal sells is a permit, so the row
  leads with the permit number - that is how staff identify one - and links through to
  it. The boilerplate's "For" (whosFor) and "Quantity" columns are gone: a permit is
  issued to the applicant on it and you cannot buy two of the same one, so both read
  the same on every row and told a reader nothing.

  Not every line is a permit, though. A cultural advisor fee is charged alongside one
  and has no number of its own - it showed as "Not yet numbered", which reads as a
  permit still waiting for one rather than a charge that will never have one.
-->
<table class="table table-hover" [class.dim]="!crud.complete">
    <thead>
        <tr>
            <th>Permit</th>
            <th>Type</th>
            <th class="text-end">Amount</th>
        </tr>
    </thead>
    @if (response) {
        <tbody>
            @for (item of response.data; track item.id) {
                <tr>
                    <td>
                        @if (item.permitNumber) {
                            <a [routerLink]="['/crm/permits', item.productId]"
                                ><b>{{ item.permitNumber }}</b></a
                            >
                        } @else if (item.isPermit) {
                            <span class="text-muted">Not yet numbered</span>
                        } @else {
                            <span class="text-muted">-</span>
                        }
                    </td>
                    <td>{{ item.productDescription || item.productLabel }}</td>
                    <td class="text-end">{{ item.price | currency: 'AUD' : '$' }}</td>
                </tr>
            }
        </tbody>
    }
</table>
